import { createSelector } from 'reselect';
import { hasResource } from '../../../util';
import { cmResources } from '../../../util/GlobalConstant';

const getAuthentication = (state) => state.authentication;

const getPolicies = createSelector(
  getAuthentication,
  (authentication) => authentication?.data
);

export const getAccessToGenericAccess = createSelector(
  getPolicies,
  (policies) => hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_GENERIC)
);

export const getAccessToDashboard = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_DASHBOARD)
);

export const getAccessToDashboardSummary = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY)
);

export const getAccessToDashboardCasesByInvestigator = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR
    )
);

export const getAccessToCreateManualCase = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION)
);

export const getAccessToOthersDepartments = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS)
);

export const getAccessToOwnCaseActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS)
);

export const getAccessToOthersCaseActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS)
);

export const getAccessToUnassignedCaseActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS
    )
);

export const getAccessToUnassignedCaseStatus = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES)
);

export const getAccessToCasesByDepartment = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT)
);

export const getAccessToCasesByInvestigator = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR
    )
);

export const getAccessToCaseResolutionReview = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW
    )
);

export const getAccessToTakeCaseActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, [
      cmResources.APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS,
      cmResources.APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS,
      cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS
    ])
);

export const getAccessToAlertList = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_ALERT_LIST)
);

export const getAccessToAlertHistory = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_ALERT_HISTORY)
);

export const getAccessToOwnAlertActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS)
);

export const getAccessToOthersAlertActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS
    )
);

export const getAccessToUnassignedAlertActions = createSelector(
  getPolicies,
  (policies) =>
    hasResource(
      policies,
      cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS
    )
);

export const getAccessToUnassignedAlertStatus = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS)
);

export const getAccessToConvertOrMergeAlerts = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, [
      cmResources.APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS,
      cmResources.APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS,
      cmResources.APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS
    ])
);

export const getAccessToSettings = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES)
);

export const getAccessToGeneralSettings = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS)
);

export const getAccessToAutomation = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS)
);

export const getAccessToRegulatoryReport = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_REGULATORY_REPORT)
);

export const getAccessToOperationalReport = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT)
);

export const getAccessToWorkflowStatus = createSelector(
  getPolicies,
  (policies) =>
    hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES)
);

export const getAccessToWhiteList = createSelector(getPolicies, (policies) =>
  hasResource(policies, cmResources.APP_7_RESOURCE_UI_CM_WHITELISTS)
);
